// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEmployerTerminationPropertiesCreateDto
 */
export interface IEmployerTerminationPropertiesCreateDto {
    /**
     * 
     * @type {Date}
     * @memberof IEmployerTerminationPropertiesCreateDto
     */
    termination_date: Date;
    /**
     * 
     * @type {Date}
     * @memberof IEmployerTerminationPropertiesCreateDto
     */
    coverage_end_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IEmployerTerminationPropertiesCreateDto
     */
    claim_last_date?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof IEmployerTerminationPropertiesCreateDto
     */
    bulk_transfer: boolean;
}

/**
 * Check if a given object implements the IEmployerTerminationPropertiesCreateDto interface.
 */
export function instanceOfIEmployerTerminationPropertiesCreateDto(value: object): value is IEmployerTerminationPropertiesCreateDto {
    if (!('termination_date' in value) || value['termination_date'] === undefined) return false;
    if (!('bulk_transfer' in value) || value['bulk_transfer'] === undefined) return false;
    return true;
}

export function IEmployerTerminationPropertiesCreateDtoFromJSON(json: any): IEmployerTerminationPropertiesCreateDto {
    return IEmployerTerminationPropertiesCreateDtoFromJSONTyped(json, false);
}

export function IEmployerTerminationPropertiesCreateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmployerTerminationPropertiesCreateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'termination_date': (new Date(json['termination_date'])),
        'coverage_end_date': json['coverage_end_date'] == null ? undefined : (new Date(json['coverage_end_date'])),
        'claim_last_date': json['claim_last_date'] == null ? undefined : (new Date(json['claim_last_date'])),
        'bulk_transfer': json['bulk_transfer'],
    };
}

export function IEmployerTerminationPropertiesCreateDtoToJSON(json: any): IEmployerTerminationPropertiesCreateDto {
    return IEmployerTerminationPropertiesCreateDtoToJSONTyped(json, false);
}

export function IEmployerTerminationPropertiesCreateDtoToJSONTyped(value?: IEmployerTerminationPropertiesCreateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'termination_date': ((value['termination_date']).toISOString()),
        'coverage_end_date': value['coverage_end_date'] == null ? undefined : ((value['coverage_end_date']).toISOString()),
        'claim_last_date': value['claim_last_date'] == null ? undefined : ((value['claim_last_date']).toISOString()),
        'bulk_transfer': value['bulk_transfer'],
    };
}

